import axios from 'axios'
import API from './index'

export default {
  forgotUsername(email){
    const url = API.BASE_URL + 'Account/ForgotUsername/' + email
    return axios.post(url, {}).then(response => {
      return response.data
    })
  },

  login(user) {
    const url = API.BASE_URL + 'Account/'
    return axios.post(url, user).then(response => {
      return response
    })
  },

  reset(email) {
    const url = API.BASE_URL + 'Account/Reset/' + email
    return axios.post(url, {}).then(response => {
      return response.data
    })
  },

  resetPassword(user) {
    const url = API.BASE_URL + 'Account/PasswordReset'
    return axios.post(url, user).then(response => {
      return response.data
    })
  },

  register(user) {
    const url = API.BASE_URL + 'Account/'
    return axios.put(url, user).then(response => {
      return response.data
    })
  }
}
